import { defineNuxtPlugin, isNuxtError } from '#imports';
import { TrackerFactory } from '~/services/tracking/TrackerFactory';
import { createErrorReporter } from '~/services/tracking/errorReporter';

export default defineNuxtPlugin((nuxtApp) => {
    /* ---------- Runtime configuration ---------- */
    const runtimeConfig = useRuntimeConfig();
    const { trackerDriver } = runtimeConfig.public;
    const tracker = TrackerFactory.create(trackerDriver);

    /* ---------- Error reporting ---------- */
    // Nuxt handles component and fatal errors itself and never rethrows them to `window`, the
    // only place PostHog's exception autocapture listens.
    const isClientNuxtError = (error: unknown) => isNuxtError(error) && error.status !== undefined && error.status >= 400 && error.status < 500;
    const reportError = createErrorReporter((error, properties) => tracker.captureException(error, properties), isClientNuxtError);
    nuxtApp.hook('vue:error', (error, instance, info) => {
        reportError(error, { vue_component: instance?.$options.__name ?? instance?.$options.name, vue_info: info });
    });
    nuxtApp.hook('app:error', (error) => reportError(error));

    return {
        provide: { tracker },
    };
});
